import React, { useEffect, useState } from "react";
import { Box, Typography, CircularProgress } from "@mui/material";
import LogsFilters from "./LogsFilters";
import LogsTable from "./LogsTable";
import PaginationControls from "./PaginationControls";
import api from "../../../services/api"; // your axios setup

const AdminLogsPage = () => {
  const [logs, setLogs] = useState([]);
  const [filters, setFilters] = useState({});
  const [page, setPage] = useState(1);
  const [pageSize] = useState(20);
  const [loading, setLoading] = useState(false);

  const fetchLogs = async () => {
    try {
      setLoading(true);
      const { data } = await api.get("/admin/logs", {
        params: { ...filters, page, pageSize },
      });
      setLogs(data.logs);
    } catch (error) {
      console.error("Error fetching logs:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchLogs();
  }, [filters, page]);

  return (
    <Box sx={{ p: 4 }}>
      <Typography variant="h4" fontWeight="bold" mb={2}>
        Logs
      </Typography>

      <LogsFilters
        filters={filters}
        setFilters={setFilters}
        resetPage={() => setPage(1)}
      />

      {loading ? (
        <CircularProgress sx={{ my: 4 }} />
      ) : (
        <>
          <LogsTable logs={logs} />
          <PaginationControls page={page} setPage={setPage} />
        </>
      )}
    </Box>
  );
};

export default AdminLogsPage;
